import store from '@/store/store.js'
import childApi from '@/api/child'
import predefinedAvatars from '@/constants/predefinedAvatars.js'

export default {
  /**
   * Change child current rule option.
   *
   * @param event
   */
  async changeMode(event) {
    const { current_user_id, device_id, reason } = event

    store.dispatch('children/loadStatus', current_user_id)
    store.dispatch('children/updateChildDevice', {
      child_id: current_user_id,
      device_id,
      data: {
        reason
      }
    })
  },

  async changeParentalMode(event) {
    const { user_id } = event

    store.dispatch('children/loadStatus', user_id)
  },

  /**
   * Add new child.
   *
   * @param event
   */
  async addChild(event) {
    const user_id = event.user.id

    const child = await childApi.get([
      "base_info",
      "latest_accumulated_screentime",
      "latest_location",
      "avatar_download_url",
      "parental_modes",
      "modes",
      "time_blocks",
      "current_rule",
      "child_status",
      "named_location_count",
      "request_count"
    ],
      [user_id]
    )

    store.dispatch('children/addChild', child[0])
  },

  /**
   * Update child.
   *
   * @param event
   */
  async updateChild(event) {
    const { age, avatar_id, name, sex, user_id } = event
    let avatar_download_url = null

    if (!predefinedAvatars[avatar_id]) {
      avatar_download_url = await childApi.getAvatarUrl(
        user_id,
        avatar_id
      )
    }

    store.dispatch('children/updateChildFromPublish', {
      child_id: user_id,
      data: {
        avatar_download_url,
        avatar_id,
        name,
        sex,
        age: parseInt(age)
      }
    })
  },

  /**
   * Delete child.
   *
   * @param event
   */
  deleteChild(event) {
    const { user_id } = event

    store.dispatch('children/removeChildFromPublish', user_id)
  },

  /**
   * Add new child device.
   *
   * @param event
   */
  addChildDevice(event) {
    const { device } = event
    const child_id = device.current_user_id

    store.dispatch('children/addChildDevice', {
      child_id,
      device
    })
  },

  /**
   * Update device last seen.
   *
   * @param event
   */
  updateDeviceLastSeen(event) {
    const { device_id, last_seen } = event

    store.dispatch('children/updateLastSeen', {
      device_id,
      last_seen
    })
  },

  /**
   * Add child device event.
   *
   * @param event
   */
  addDeviceEvent(event) {
    const { user_id, device_event } = event
    const { event_name } = device_event

    switch(event_name) {
      case 'search':
        if (device_event.details.engine === '4') {
          store.dispatch('children/addYoutubeSearchEvent', {
            user_id,
            device_event
          })
        } else {
          store.dispatch('children/addSearchEvent', {
            user_id,
            device_event
          })
        }

        break

      case 'block':
      case 'warn':
        store.dispatch('children/addBlocksAndAlertsEvent', {
          user_id,
          device_event
        })

        break

      default:
        break
    }
  },

  /**
   * Add youtube view.
   *
   * @param event
   */
  addYoutubeView(event) {
    const { user_id, youtube_event } = event

    store.dispatch('children/addYoutubeViewEvent', {
      user_id,
      youtube_event
    })
  },

  /**
   * Add new feed item.
   *
   * @param event
   */
  addFeedItem(event) {
    const { feed_item } = event

    store.dispatch('feed/addNewFeedItem', feed_item)
  },

  /**
   * Change account license.
   *
   * @param event
   */
  changeLicense(event) {
    const { license } = event

    store.dispatch('auth/setLicenseFromPublish', license)
  },

  /**
   * Remove child device.
   *
   * @param event
   */
  removeChildDevice(event) {
    const { device_id } = event

    store.dispatch('children/removeChildDeviceFromPublish', device_id)
  },

  /**
   * Add child request access.
   *
   * @param event
   */
  addRequestAccess(event) {
    const { request_access } = event

    store.dispatch('requests/addRequests', request_access)
  },

  /**
   * Remove child request access.
   *
   * @param event
   */
  removeRequestAccess(event) {
    const { request_access } = event

    store.dispatch('requests/removeRequest', request_access[0])
  },

  /**
   * Update child schedule.
   *
   * @param event
   */
  async updateSchedule(event) {
    const { time_blocks, user_id } = event

    const child = await childApi.get(
      [
        'current_rule',
        'child_status',
        'latest_accumulated_screentime'
      ],
      [user_id]
    )

    const { latest_accumulated_screentime, current_rule, status } = child[0]

    store.dispatch('children/updateChildFromPublish', {
      child_id: user_id,
      data: {
        status,
        time_blocks,
        current_rule,
        latest_accumulated_screentime
      }
    })
  },


  /**
   * Update child settings.
   *
   * @param event
   */
  updateChildSettings(event) {
    const { settings, user_id } = event

    store.dispatch('children/updateChildFromPublish', {
      child_id: user_id,
      data: {
        settings
      }
    })
  },

  /**
   * Update child category setting.
   *
   * @param event
   */
  updateCategorySetting(event) {
    const { user_id, category_settings } = event

    store.commit('children/updateCategorySettings', {
      user_id,
      category_settings: category_settings[0]
    })
  },

  /**
   * Remove child category setting.
   *
   * @param event
   */
  removeCategorySetting(event) {
    const { user_id, category_settings } = event

    store.commit('children/removeCategorySettings', {
      user_id,
      category_id: category_settings[0].id
    })
  },

  /**
   * Add child custom category setting.
   *
   * @param event
   */
  addCustomCategory(event) {
    const { categories } = event

    store.dispatch('categories/addCustomCategory', categories[0])
  },

  /**
   * Update child custom category setting.
   *
   * @param event
   */
  updateCustomCategory(event) {
    const { categories } = event

    store.dispatch('categories/updateCustomCategory', categories[0])
  },

  /**
   * Remove child custom category setting.
   *
   * @param event
   */
  removeCustomCategory(event) {
    const { category_id } = event

    store.dispatch('categories/removeCustomCategory', category_id)
  },

  /**
   * Update child application setting.
   *
   * @param event
   */
  updateAppSetting(event) {
    const { user_id, app_settings } = event

    store.commit('children/updateAppSettings', {
      user_id,
      app_settings: app_settings[0]
    })
  },

  /**
   * Add url settings.
   *
   * @param event
   */
  addUrlSetting(event) {
    const { user_id, url_settings } = event

    store.dispatch('children/addUrlSettings', {
      user_id,
      url_settings: url_settings[0]
    })
  },

  /**
   * Remove url settings.
   *
   * @param event
   */
  removeUrlSetting(event) {
    const { user_id, url_settings } = event

    store.dispatch('children/removeUrlSettings', {
      user_id,
      url_settings: url_settings[0]
    })
  },

  /**
   * Add named location.
   *
   * @param event
   */
  addNamedLocation(event) {
    const { named_locations } = event

    store.dispatch('geofence/addNamedLocation', named_locations[0])
  },

  /**
   * Update named location.
   *
   * @param event
   */
  updateNamedLocation(event) {
    const { named_locations } = event

    store.dispatch('geofence/updateNamedLocation', named_locations[0])
  },

  /**
   * Remove named location.
   *
   * @param event
   */
  removeNamedLocation(event) {
    const { named_location_id } = event

    store.dispatch('geofence/removeNamedLocation', named_location_id)
  },

  /**
   * Update named location alert settings.
   *
   * @param event
   */
  updateNamedLocationSettings(event) {
    const { alert_settings } = event

    store.dispatch('geofence/updateAlertSettiings', alert_settings)
  },

  /**
   * Update child screen time.
   *
   * @param event
   */
  updateScreenTime(event) {
    const { user_id, usage_date, total_screen_time_in_seconds, active } = event

    store.dispatch('children/updateChildFromPublish', {
      child_id: user_id,
      data: {
        latest_accumulated_screentime: {
          date: usage_date.slice(0, 10),
          sum_in_seconds: total_screen_time_in_seconds
        }
      }
    })

    store.dispatch('children/updateChildStatus', {
      child_id: user_id,
      active
    })
  },

  /**
   * Update child latest location.
   *
   * @param event
   */
  addLocation(event) {
    const { user_id } = event

    store.dispatch('children/updateChildLocation', user_id)
  },

  /**
   * Update social media setting.
   *
   * @param event
   */
  updateSocialMediaSetting(event) {
    const { user_id, social_media_setting } = event

    store.commit('children/updateProtectedSocialMedia', {
      user_id,
      social_media_setting
    })

    store.commit('children/updateUnsupportedSocialMedia', {
      user_id,
      social_media_setting
    })
  },

  /**
   * Update all social media settings.
   *
   * @param event
   */
  updateAllSocialMedia(event) {
    const {
      user_id,
      protected_social_media_settings,
      unsupported_social_media_settings
    } = event

    store.commit('children/setProtectedSocialMedia', {
      user_id,
      protected_social_media_settings
    })

    store.commit('children/setUnsupportedSocialMedia', {
      user_id,
      unsupported_social_media_settings
    })
  },

  /**
   * Update all unsupported social media settings.
   *
   * @param event
   */
  updateUnsupportedSocialMedia(event) {
    const {
      user_id,
      unsupported_social_media_settings
    } = event

    store.commit('children/setUnsupportedSocialMedia', {
      user_id,
      unsupported_social_media_settings
    })
  }
}